import Footer from './Footer';
import { FooterProps } from './Footer.interface';

export { Footer };
export type { FooterProps };
